<template>
  <header class="navBar">
    <div class="back" @click="back">
      <img src="/static/img/left2.png" />
    </div>
    <div class="ellipsis">{{$t(value.centerTitle)}}</div>
    <div class="ellipsis">
      <div v-if="value.rightTitle!=undefined" @click="handle(value.rightTitle.fnName)">{{$t(value.rightTitle.label)}}</div>
    </div>
  </header>
</template>
<style scoped>
  header {
    color: #fff;
    font-size: 0.425rem;
    height: 1.489rem;
    line-height: 1.489rem;
    padding: 0 0.266rem;
    position: relative;
  }

  header>div:first-child {
    width: 1.330rem;
    position: absolute;
    bottom: 0;
  }

  header>div:nth-child(2) {
    text-align: center;
    width:5.320rem;
    margin: 0 auto
  }

  header>div:last-child {
    color: #fff;
    position: absolute;
    right: 0.266rem;
    top: 0;
    width: 2.660rem;
    text-align: right
  }

  .back img {
    width: 0.372rem;
    margin-bottom: -0.106rem
  }

  .appInner .navBar>div:last-child {
    top: 0.532rem
  }
  .iphoneX .navBar>div:last-child {
    top: 1.064rem
  }

</style>
<script>
  export default {
    props: ['value'],
    methods: {
      back() {
        history.back()
      },
      handle(fnName) {
        this.$emit(fnName);
      },
    },

  }

</script>
